"use client";

import { createTheme } from "@mui/material/styles";

const theme = createTheme({});

export default theme;
